import type { ChatMode } from "@store/types";

export const AGENT_CHAT_MODE: Exclude<ChatMode, "qa"> = "agent-performance";

/**
 * 归一化聊天模式 —— 后端只认 `agent-performance` / `qa` 两个值，其余一律落 `qa`。
 *
 * 提到这里是因为有**两个**消费方且必须给出同一个值：
 * 1. `useChats` 发请求时的 `chatMode`；
 * 2. `Sender` 的 `chat_message_sent` 埋点 `chat_mode` 字段。
 *
 * 各写一份就会出现「上报的模式和真正请求的模式不是同一个」——
 * 而下游 `edgen_events` 正是拿它区分 Fast / Think 两种会话（native `ChatScreen.kt`
 * 的 `resolveAllowedChatMode` 是同一套规则，两端必须逐字一致）。
 */
export const resolveAllowedChatMode = (chatMode?: string): ChatMode =>
  chatMode === AGENT_CHAT_MODE ? AGENT_CHAT_MODE : "qa";
